<template>
  <v-card
    class="mx-auto info-card permission-form"
    :class="{ new: (id === 0), edit: (id > 0) }"
    flat
  >
    <v-card-title>
      <span class="headline">
        <v-icon>{{ lang.permissions.icon }}</v-icon>
        {{ (id > 0 ? `${lang.permissions.edit.title} #${id}` : `${lang.permissions.new.title}`) }}
      </span>
      <v-spacer></v-spacer>
      <v-icon
        @click="reset_"
        class="dialog-close-btn"
      >
        {{ (id > 0 ? 'mdi-close' : 'mdi-broom') }}
      </v-icon>
    </v-card-title>
    <div class="permission-form-content">
      <v-form
        ref="SaveForm"
        v-model="valid"
        lazy-validation
        :disabled="get_interface.loading"
      >
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-row class="px-3 py-2 form-row">
              <v-col cols="9" class="pa-1">
                <v-text-field
                  v-model="selected.name"
                  :label="lang.permissions.datatable.headers.title"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  :rules="lang.permissions.new.rules.titleRules"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-1">
                <v-select
                  v-model="selected.color"
                  :items="colors"
                  :label="lang.permissions.new.color"
                  :no-data-text="lang.permissions.new.no_colors"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  :item-color="selected.color"
                  item-text="title"
                  item-value="value"
                  class="color-select"
                  filled
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      class="chip--select-multi color-chip"
                      :color="data.item.value"
                    ></v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-icon>
                      <v-icon :color="item.value">mdi-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title :class="`${item.value}--text`">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <Selector
              v-if="typeof selected.permissions === 'object'"
              v-model="selected.permissions"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <v-card-actions>
      <v-btn
        @click="save_"
        :disabled="get_interface.loading"
        :loading="get_interface.loading"
        color="green"
        class="save-btn"
        filled
      >
        {{ lang.permissions.actions.save }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Selector from './selector/Selector'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, save, utils ],
  components: { Selector },
  data () {
    return {
      nodialog: true,
      valid: false
    }
  },
  computed: {
    colors () {
      return defaults.options.permissions.colors
    }
  },
  methods: {
    reset_ () {
      this.$emit('closed', true)
      if (this.$refs.SaveForm) this.$refs.SaveForm.resetValidation()
    },
    save_ () {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 9, data: { page: 'permissions', ...this.selected }, item: this.selected.id })
      }
    }
  },
  created () {
    this.selected = { ...this.value }
    if (this.$refs.SaveForm) this.$refs.SaveForm.resetValidation()
  }
}
</script>

<style src="../styles/form.scss" lang="scss"></style>
